export default __webpack_public_path__ + "static/media/February2011.7434f88d.png";